import { Outlet } from "react-router-dom";
import {
    Row,
    Col } from "react-bootstrap";

import NavSide from "./components/NavSide";

export default function NewProjOutlet(){
  /* Define Items in the Sidebar */
  const sideNav = [
    {
      title: "Project Information",
      page: "info"
    },
    {
      title: "Clone",
      page: "clone",
    },
    {
      title: "Templates",
      page: "temps",
    },
    {
      title: "Users",
      page: "users"
    }
  ]
  return(
    <>
      <Row className="page-head">
        <h1>
          Create a New Project
        </h1>
      </Row>
      <Row>
        <Col sm="2" className="mx-0 px-0">
          <NavSide elements={sideNav} finalBtn="Create" type="projs"/>
        </Col>
        <Col className="px-5">
          <Outlet />
        </Col>
      </Row>
    </>
  );
}